export default "__VITE_ASSET__7fa39480__"